/**
 * Person attribute names the profile editors treat specially.
 *
 * The reserved-name lists themselves live in `@/utils/attributes`, because the
 * data index asks the same questions of the same names and two copies would
 * eventually disagree. What stays here is the vocabulary only the profile
 * editors use.
 */
import {
  CIO_EMAIL_TRACKING_CONSENT,
  CREATED_IN_CIO_AT,
  PERMANENT_ATTRIBUTES,
  RESTRICTED_ATTRIBUTES,
  TEST_USER,
  TEST_USER_DOUBLE_OPT_IN,
  TIMEZONE,
  TIMEZONE_VALID,
} from '@/utils/attributes';

export {
  CIO_EMAIL_TRACKING_CONSENT,
  CREATED_IN_CIO_AT,
  PERMANENT_ATTRIBUTES,
  RESTRICTED_ATTRIBUTES,
  TEST_USER,
  TEST_USER_DOUBLE_OPT_IN,
  TIMEZONE,
  TIMEZONE_VALID,
};

export const IdentifierKey = {
  Id: 'id',
  CioId: 'cio_id',
  Email: 'email',
  Phone: 'phone',
} as const;

export type IdentifierKey = (typeof IdentifierKey)[keyof typeof IdentifierKey];

/** A JSON attribute; its nested keys are listed as `cio_subscription_preferences.<path>`. */
export const CIO_SUBSCRIPTION_PREF_KEY = 'cio_subscription_preferences';

/** Attributes the backend owns for a person; they can never be edited by hand. */
export const IMMUTABLE_CUSTOMER_ATTRIBUTES: readonly string[] = [TEST_USER, TEST_USER_DOUBLE_OPT_IN];
